
export class UserClk {
  reference: string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  address: string;
  status: string;
  username: string;
  role: any;
  plainPassword: string;
  picture: any;
  country: any;
  city: any;
  callCenter: any;
  platform: any;
  timezoneOffset: number;
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/users/users-clk/user-clk.model.ts